import PropTypes from 'prop-types';
import useSnackbar from 'src/hooks/useCustomSnackbar';
import { useImperativeHandle, forwardRef, useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import moment from 'moment';
import { Box } from '@mui/material';
import ReminderPresetSelector from '../ReminderPresetSelector';
import { FormProvider, RHFTextField } from '../hook-form';
import { useSelector, dispatch } from '../../redux/store';
import { addScheduleReminder, saveNewLeadDetail } from '../../redux/slices/lead';
import { ScheduleReminderSchema } from '../../validations/validations';

const FollowUp = forwardRef(({ handleClose, type }, ref) => {
    const { enqueueSnackbar } = useSnackbar();
    const { practiceId } = useSelector((state) => state.practiceTreatmentList);
    const { createLead, followLead, tableRowLead } = useSelector((state) => state.lead);
    const [activeTime, setActiveTime] = useState('custom reminder');
    const [assignToState, setAssignToState] = useState([]);

    useImperativeHandle(
        ref,
        () => ({
            async submit() {
                await handleSubmit(onSubmit)();
            },
        }),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    const defaultValues = {
        reminder: 'CALL',
        reminderDateTime: null,
        assignTo: [],
        ReminderNotes: '',
        otherNotes: '',
        customReminder: '',
        callReminder: ''
    };

    const methods = useForm({
        resolver: yupResolver(ScheduleReminderSchema),
        defaultValues
    });
    const onSubmit = (data) => {
        const leadId = followLead && followLead.id || createLead && createLead.id || '';
        if (data.reminderDateTime) {
            const assignedUser = assignToState?.map(el => el?.id).filter(Boolean) || [];
            const addReminderObj = {
                method: data.reminder,
                datetime: `${moment(data.reminderDateTime).format('DD-MM-YYYY HH:mm:ss')}.0Z`,
                note: data.ReminderNotes,
                is_completed: false,
                assignees: assignedUser,
                group: 'FOLLOW_UP',
                lead: leadId,
                lead_treatment: type === 'scheduleReminder' ? tableRowLead : tableRowLead?.treatment_id
            };
            dispatch(saveNewLeadDetail({ addReminder: addReminderObj }));
            dispatch(addScheduleReminder(addReminderObj, practiceId, handleSuccess, 'LeadDetail'));
        } else {
            enqueueSnackbar('Please select tab', {
                variant: 'warning',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                }
            });
        }
    };

    const handleSuccess = (data) => {
        if (data.success) {
            enqueueSnackbar(data.message || '', {
                variant: data.success ? 'success' : 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                }
            });
            handleClose();
        }
        if (!data.success) {
            enqueueSnackbar(data.message.message || '', {
                variant: data.success ? 'success' : 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                }
            });
            handleClose();
        }
    };

    const {
        control,
        setValue,
        handleSubmit,
        clearErrors,
    } = methods;

    useEffect(() => {
        setValue('customReminder', activeTime);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTime]);


    return (
        <Box sx={{ width: '100%', pt: '30px' }}>
            <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                <ReminderPresetSelector
                    control={control}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    activeTime={activeTime}
                    onPresetChange={setActiveTime}
                    assignToState={assignToState}
                    setAssignTo={setAssignToState}
                    showStepBadges={false}
                />
                <RHFTextField
                    sx={{ width: '100%', mt: 0 }}
                    name="ReminderNotes" multiline rows={4}
                    label="Reminder notes"
                    placeholder="Add notes here"
                    InputLabelProps={{ shrink: true }}
                />
            </FormProvider>
        </Box>
    );
});

FollowUp.propTypes = {
    handleClose: PropTypes.func,
    type: PropTypes.any,
};

export default FollowUp;